import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '@ng-darwin/config';
import { AppConfigInterface, EndPointsInterface } from '../models/app-config.interface';
import { AggregatioRequestInterface, AggregationResponseInterface } from '../models/aggregation.interface';
import { lastValueFrom } from 'rxjs';

/**
 * @description Injectable
 * @class NoPsd2Service
 */
@Injectable({
  providedIn: 'root'
})
export class NoPsd2Service {

  private readonly _appConfig: AppConfigInterface = {};
  private readonly _endPoints: EndPointsInterface = {};
  private _baseURL = '';

  /**
   * @description Creates an instance of NoPsd2Service.
   * @param _http HttpClient
   * @param _configService ConfigService
   */
  constructor(
    private readonly _http: HttpClient,
    private readonly _configService: ConfigService
  ) {
    this._appConfig = this._configService.config.app || {};
    this._endPoints = this._appConfig.endPoints || {};
    this._baseURL = (sessionStorage.getItem('app-unique-id') === this._configService.config.app['cdncApplication']
      ? this._appConfig.baseUrlCDNC
      : this._appConfig.baseUrl) as string;
  }

  /**
   * @description postAggregation
   * @param request AggregatioRequestInterface
   * @returns Promise<AggregationResponseInterface>
   */
  postAggregation(request: AggregatioRequestInterface): Promise<AggregationResponseInterface> {
    const url = `${this._baseURL}/${this._endPoints.noPsd2}`;
    return lastValueFrom(this._http.post<AggregationResponseInterface>(url, request));
  }
}
